module.exports = __webpack_public_path__ + "img/plus-2.471ee821.svg";